import {defineStore} from 'pinia';
import {OIDC_STATE_PREFIX} from '../api/authentication/OIDCHelper';
import {computed, ref, watch} from 'vue';
import {useSecurityStorage} from '../shared/composables/useSecurityStorage';

function getPrefixedKey(key: string, prefix = OIDC_STATE_PREFIX) {
    return `${prefix}_${key}`;
}

export const useOidcStore = defineStore('oidc', () => {
    /**
     * OIDC access token
     */
    const accessToken = useSecurityStorage<string>(getPrefixedKey('accessToken'), null);

    /**
     * OIDC id token
     */
    const idToken = useSecurityStorage<string>(getPrefixedKey('idToken'), null);

    const hasOidcToken = computed(() => !!accessToken.value || !!idToken.value);

    const isRefreshing = ref(false);

    watch(hasOidcToken, newValue => {
        if (newValue) {
            isRefreshing.value = false;
        }
    });

    /**
     * Clears OIDC tokens
     */
    function clearOidc() {
        accessToken.value = null;
        idToken.value = null;
    }

    return {
        clearOidc,
        accessToken,
        idToken,
        hasOidcToken,
        isRefreshing,
    };
});
